import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'pl',
  resources: {
    en: {},
    pl: {
      profileForm: {
        errors: {
          'error-invalid-email':
            'Błędny format e-mail. Sprawdź, czy zawiera wszystkie znaki, jak w przykładzie: nazwa@domena.pl',
          required: 'Pole jest wymagane',
          minLength: 'Wartość musi się składać przynajmniej z {{count}} znaków',
          maxLength: 'Wartość jest zbyt długa',
          'error-invalid-length': 'Niepoprawna długość',
          emailExistsMessage: 'e-mail instnieje',
          duplicated: 'Wartość już zajęta',
          'error.duplicated.attribute.nickname':
            'Użytkownik o takiej nazwie już istnieje',
          'error-pattern-nickname':
            'Nazwa użytkownika powinna zawierać jedynie litery oraz cyfry',
          'errors.error-pattern-nickname':
            'Nazwa użytkownika powinna zawierać jedynie litery oraz cyfry',
        },
        snackbar: {
          success: 'Pomyślnie zapisano zmiany',
        },
        fields: {
          email: 'E-mail',
          firstName: 'Imię',
          lastName: 'Nazwisko',
          username: 'Nazwa użytkownika',
        },
        helperText: {
          username: 'Ta nazwa jest dostępna publicznie',
        },
        title: 'Informacje o koncie',
        subtitle: 'Twoje dane',
        submitButton: 'Aktualizuj',
        removeAccount: 'Usuń konto',
      },
      passwordForm: {
        title: 'Zarządzaj hasłem',
        subtitle: 'Tutaj możesz zaktualizować swoje hasło.',
        createdAt: 'Hasło zostało utworzone:',
        submitButton: 'Zmień hasło',
      },
      sessions: {
        title: 'Aktywne sesje',
        subtitle:
          'Jeśli nie rozpoznajesz urządzenia na poniższej liście, wyloguj się z niego i zmień hasło.',
        logout: 'Wyloguj',
        current: 'Aktualna',
        logoutSession: 'Wyloguj z sesji',
        refresh: 'Odśwież',
        openModal: 'Wyloguj ze wszystkich urządzeń',
        table: {
          name: 'Sesja',
          lastActive: 'Ostatnio aktywna',
          expires: 'Wygaśnie',
          actions: 'Akcje',
        },
        modal: {
          title: 'Czy na pewno chcesz się wylogować ze wszystkich urządzeń?',
          subtitle:
            'Po wylogowaniu, zakończy się również obecna sesja, a Ciebie przekierujemy do ekranu logowania, czy chcesz kontynuować?',
          cancel: 'Anuluj',
          confirm: 'Tak, wyloguj ze wszystkich urządzeń',
          confirmMobile: 'Wyloguj ze wszystkich urządzeń',
        },
      },
      menu: {
        welcome: 'Miło Cię widzieć!',
        account: 'Konto',
        password: 'Hasło',
        linkAccount: 'Połącz z kontem',
        linkAccountShort: 'Połącz',
        activeSessions: 'Aktywne sesje',
        activeSessionsShort: 'Sesje',
        returnToHomepage: 'Wróć do Odrabiamy',
        returnToHomepageShort: 'Wróć',
        logout: 'Wyloguj',
      },
      linkedAccounts: {
        title: 'Połącz z kontem',
        subtitle: `Jeśli chcesz logować się do Odrabiamy jednym kliknięciem za pomocą
        zewnętrznego serwisu takiego jak np. Google, połącz ze sobą istniejące
        konta.`,
        linkedTitle: 'Połączone',
        unlinkedTitle: 'Dostępne serwisy',
        unlinkButton: 'Rozłącz',
        linkButton: 'Połącz z kontem Odrabiamy',
      },
    },
  },
});

export { i18n };
